import { Typography } from '@mui/material'
import { CellProps } from 'react-table'

import colors from '@/assets/scss/_themes-vars.module.scss'
import { OfflineConsultation } from '@/core/offline'

export function PatientNameCell({ value }: CellProps<OfflineConsultation, OfflineConsultation['patient']['userInfo']['name']>) {
  return (
    <Typography variant="body2" sx={{ color: colors.gray600, fontSize: '15px' }}>
      {value}
    </Typography>
  )
}
